import { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const AgeVerification = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà confirmé son âge
    const ageVerified = localStorage.getItem('ageVerified');
    if (!ageVerified) {
      setShowPopup(true);
    }
  }, []);

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowPopup(false);
  };

  const handleDecline = () => {
    // Rediriger vers une page d'avertissement ou fermer
    window.location.href = 'https://www.anj.fr/';
  };

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4">
      <div className="bg-dark-card border-2 border-toxic-green rounded-2xl p-8 max-w-md w-full relative">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-toxic-green/20 p-4 rounded-full">
            <AlertTriangle className="w-12 h-12 text-toxic-green" />
          </div>
        </div>

        <h2 className="text-3xl font-bold text-center mb-4 text-white">
          Vérification d'Âge
        </h2>

        <p className="text-gray-300 text-center mb-6 leading-relaxed">
          Ce site est réservé aux personnes de 18 ans et plus. Les paris en ligne sont interdits aux mineurs.
        </p>

        <p className="text-gray-400 text-center mb-8 text-sm">
          En cliquant sur "J'ai 18 ans ou plus", vous confirmez que vous êtes majeur et que vous acceptez nos conditions d'utilisation.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={handleDecline}
            className="flex-1 px-6 py-3 border-2 border-gray-600 text-gray-300 font-semibold rounded-lg hover:border-gray-500 transition-colors"
          >
            J'ai moins de 18 ans
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 px-6 py-3 bg-toxic-green text-dark-bg font-bold rounded-lg hover:bg-opacity-80 transition-all"
          >
            J'ai 18 ans ou plus
          </button>
        </div>

        <p className="text-gray-500 text-xs text-center mt-6">
          Pour plus d'informations sur le jeu responsable, consultez{' '}
          <a href="https://www.anj.fr/" target="_blank" rel="noopener noreferrer" className="text-toxic-green hover:underline">
            l'ANJ
          </a>
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;

